export enum ProfilePictureModifier {
  ALIGN_TOP = 'profile-picture-name--align-top',
}
